import { POST } from 'utils/requests.utils'

const BASE_URL = '/common/traffic_source_cookies'

export const postTrafficCookies = (data) => POST(`${BASE_URL}`, data)
